import { computed, Injectable, signal } from "@angular/core";
import { MergePatient } from "../merge-patient";

@Injectable()
export class MergePatientsSelectionService {
    private readonly _selectedPatients = signal<MergePatient[]>([]);

    readonly parentPatient = computed(() => this._selectedPatients()[0]);
    readonly childPatient = computed(() => this._selectedPatients()[1]);
    readonly isEmpty = computed(() => this._selectedPatients().length === 0);
    readonly validSelection = computed(() => this._selectedPatients().length === 2);

    select(patient: MergePatient) {
        const selectedPatients = this._selectedPatients();
        const [parent, child] = [selectedPatients[0], selectedPatients[1]];

        if (!patient || parent?.id == patient.id || child?.id == patient.id) {
            return;
        }

        if ((parent && child) || !parent) {
            this._selectedPatients.update(_ => [patient]);
        } else {
            this._selectedPatients.update(_ => [parent, patient]);
        }
    }

    unselect(patient: MergePatient) {
        if (!patient) {
            return;
        }

        const selectedPatients = this._selectedPatients();

        if (selectedPatients[0]?.id == patient.id) {
            this._selectedPatients.update(_ => []);
        } else if (selectedPatients[1]?.id == patient.id) {
            this._selectedPatients.update(_ => [selectedPatients[0]]);
        }
    }

    clearSelection() {
        this._selectedPatients.update(() => []);
    }

    swapSelection() {
        if (!this.validSelection()) {
            return;
        }

        this._selectedPatients.update(_ => [this.childPatient(), this.parentPatient()]);
    }
}
